import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Card, Link, Typography } from '@drone-js/core';
import { withQueryString } from 'core/service/Url/Url';
import { selectCidFromBootstrap, selectCmsFromBootstrap, selectFeatureBehaviorFromBootstrap } from 'store/slice/bootstrap';
import { TopDestination } from 'core/type/ActivitiesTopDestinations.types';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesTopDestinationCardClickEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesTopDestinationCardClickEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { RecentSearchItem } from 'core/type/SuggestionResult.types';
import { TextSearchType } from 'core/type/TextSearch.types';
import { MAX_RECENT_SEARCH, setRecentlySearch } from 'component/common/TextSearch/suggestionUtils';
import { ActivityImage } from 'component/common/ActivityImage/ActivityImage';

export const TopActivityDestinationItem: React.FC<{ destination: TopDestination; index: number }> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    const cid = useSelector(selectCidFromBootstrap);
    const searchPageUrl = withQueryString(encodeURI(props.destination.cityUrl), String(cid));
    const isSearchBoxFeatureGroup = useSelector(selectFeatureBehaviorFromBootstrap).SearchBoxFeatureGroup;

    const onCardClick = () => {
        trackElementEvent<ActivitiesTopDestinationCardClickEventActivitiesFieldsV1>(
            ActivitiesTopDestinationCardClickEventActivitiesManifestV1.ids,
            { action_element_index: props.index + 1, action_element_value: props.destination.cityId },
            { city_id: props.destination.cityId },
        );

        const recentClick: RecentSearchItem = {
            id: props.destination.cityId,
            type: TextSearchType.City,
            activityName: '',
            url: props.destination.cityUrl,
            isUrlWithPrefix: true,
            cityName: props.destination.cityName ?? props.destination.cityNameEnglish,
            cityId: props.destination.cityId,
            countryName: props.destination.countryName || '',
            supplierId: undefined,
        };

        isSearchBoxFeatureGroup && setRecentlySearch(recentClick, MAX_RECENT_SEARCH);
    };

    return (
        // eslint-disable-next-line @agoda/agoda-a11y/no-inaccessible-drone-link -- @agoda/agoda-a11y/no-inaccessible-drone-link[8ee2d6ec-170a-42e6-8bef-596877038e5c]
        <Link
            data-testid="activities-top-destination-card"
            data-element-name="activities-top-destination-card"
            display="block"
            width="100%"
            height="100%"
            onClick={onCardClick}
            href={searchPageUrl}
        >
            <Card data-testid="activities-top-destination-item" type="interactive">
                <ActivityImage alt={cms[154409]} data-testid="activities-top-destination-item-image" src={props.destination.imageUrl} loading="immediate" responsive="original" />
                <Box px="8" pt="8" pb="16" display="flex" flexDirection="column">
                    <Typography tag="h3" variant="body-default" aria-level={2}>
                        {props.destination.cityName}
                    </Typography>
                    <Typography variant="body-s" textColor="base.subtle" pt="4">
                        {cms[154409]}
                    </Typography>
                </Box>
            </Card>
        </Link>
    );
};
TopActivityDestinationItem.displayName = 'TopActivityDestinationItem';
